import { render, staticRenderFns } from "./_preAddMatchLog.vue?vue&type=template&id=067679b2&scoped=true&lang=pug&"
import script from "./_preAddMatchLog.vue?vue&type=script&lang=js&"
export * from "./_preAddMatchLog.vue?vue&type=script&lang=js&"
import style0 from "./_preAddMatchLog.vue?vue&type=style&index=0&id=067679b2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "067679b2",
  null
  
)

export default component.exports